import { put, select, call } from "redux-saga/effects"

import { userLogoutAction } from "Containers/Login/actions"

import {
  setErrorMessage,
  setSuccessMessage,
  setWarningMessage,
  setInfoMessage,
} from "Containers/Messages/actions"

import { selectLangageID } from "Containers/Login/selectors"

// Traduction
import { getTranslationString } from "Utils/getTranslation"

const mappingCode_SpecificCode = {
  SUCCESS_TO_DELETE_GROUP: {
    maryanne: "SUCCESS_TO_DELETE_ENTITY",
  },
  SUCCESS_TO_ARCHIVE_GROUP: {
    maryanne: "SUCCESS_TO_ARCHIVE_ENTITY",
  },
  SUCCESS_TO_UNARCHIVE_GROUP: {
    maryanne: "SUCCESS_TO_UNARCHIVE_ENTITY",
  },
  SUCCESS_TO_DELETE_GROUPS: {
    maryanne: "SUCCESS_TO_DELETE_ENTITIES",
  },
  SUCCESS_TO_ARCHIVE_GROUPS: {
    maryanne: "SUCCESS_TO_ARCHIVE_ENTITIES",
  },
  SUCCESS_TO_UNARCHIVE_GROUPS: {
    maryanne: "SUCCESS_TO_UNARCHIVE_ENTITIES",
  },
}

const getSpecificCode = (code, businessTag) => {
  if (!code || !businessTag) return code
  if (!mappingCode_SpecificCode?.[code]?.[businessTag]) return code
  return mappingCode_SpecificCode[code][businessTag]
}

export const getMessageObject = (response, langageId, businessTag) => {
  const code = getSpecificCode(response?.code, businessTag)
  const translatedMessage =
    (code && getTranslationString(code, langageId)) ||
    getTranslationString("UNKNOWN_ERROR", langageId) ||
    code ||
    "UNKNOWN_ERROR"
  return { code: code || "UNKNOWN_ERROR", message: translatedMessage }
}

export const responseTypeIsError = response => response?.type === "error"

export const responseTypeIsWarning = response => response?.type === "warning"

export const responseTypeIsSuccess = response => response?.type === "success"

export const responseTypeIsInfo = response => response?.type === "info"

const codesToDisconnectUser = [
  "TOKEN_EXPIRED",
  "BAD_TOKEN",
  "UNKNOWN_TOKEN_ERROR",
  "TOKEN_ERROR",
  // "NO_TOKEN", //=> no token should not disconnect user because it's a developpement error
]
const shouldLogout = respCode => codesToDisconnectUser.includes(respCode)

//GENERATOR
export function* handleResp({ response, displayMessageToUser, businessTag }) {
  const { showError, showSuccess } = displayMessageToUser
  const isError = responseTypeIsError(response)
  if (shouldLogout(response?.code)) yield put(userLogoutAction())
  if (isError) {
    yield call(manageErrorGenerator, { response, showMessageToUser: showError, businessTag })
    return
  }
  yield call(manageSuccessGenerator, { response, showMessageToUser: showSuccess, businessTag })
}

export function* manageErrorGenerator({ response, showMessageToUser, businessTag }) {
  console.error(response)
  console.log(`☠️ error: ${response} error code: ${response?.code}, full response:`, response)
  const langageId = yield select(selectLangageID)
  if (showMessageToUser) {
    const errorObject = getMessageObject(response, langageId, businessTag)
    yield put(setErrorMessage(errorObject))
  }
  if (shouldLogout(response?.code)) yield put(userLogoutAction())
}

export function* manageSuccessGenerator({ response, showMessageToUser, businessTag }) {
  const langageId = yield select(selectLangageID)
  if (showMessageToUser) {
    const successMessageObject = getMessageObject(response, langageId, businessTag)
    yield put(setSuccessMessage(successMessageObject))
  }
}

export function* manageWarningGenerator({ response, showMessageToUser, businessTag }) {
  const langageId = yield select(selectLangageID)
  if (showMessageToUser) {
    const successMessageObject = getMessageObject(response, langageId, businessTag)
    yield put(setWarningMessage(successMessageObject))
  }
}

export function* manageInfoGenerator({ response, showMessageToUser, businessTag }) {
  const langageId = yield select(selectLangageID)
  if (showMessageToUser) {
    const successMessageObject = getMessageObject(response, langageId, businessTag)
    yield put(setInfoMessage(successMessageObject))
  }
}
